import { memo } from 'react';
import {
    Card,
    Image,
    RouterLink,
    Section,
    Tabs,
    Title,
} from '@zmedia/bm-soccer-ui/components';
import { URL_SOCCER_PAGE } from '@zmedia/bm-soccer-ui/modules/shared';
import styles from './style.module.scss';

export function PlayerHeader(props: any) {
    const { team, name, avatar, tab, path, activeTab } = props;
    return (
        <Section className={styles['player-header']}>
            <Card>
                <Card.Image>
                    <Image src={avatar} alt={name} />
                </Card.Image>
                <Card.Content>
                    <Title renderAs="h2">{name}</Title>
                    {team?.id && (
                        <RouterLink
                            className={styles['subtitle']}
                            to={`${URL_SOCCER_PAGE.SUBPATH}${team.path}`}
                            title={team.name}
                        >
                            <Image
                                src={team?.logo}
                                alt={'Đội bóng ' + team.name}
                            />
                            {team?.name}
                        </RouterLink>
                    )}
                </Card.Content>
            </Card>
            <Tabs tabs={tab.items} pathUrl={path} activeTab={activeTab}></Tabs>
        </Section>
    );
}

export default memo(PlayerHeader);
